import { Injectable } from '@angular/core';
import { BazisConfigurationService } from '@bazis/configuration.service';
import * as bazisConfig from '@bazis/configuration.service';
import { IsActiveMatchOptions } from '@angular/router';
import { MaskSettings } from '@bazis/form/models/form-element.types';

export const AVAILABLE_LANGUAGES = ['ru', 'en'];
export const SELECTED_LANGUAGE =
    localStorage.getItem('lang') &&
    AVAILABLE_LANGUAGES.indexOf(localStorage.getItem('lang') as string) > -1
        ? localStorage.getItem('lang') || AVAILABLE_LANGUAGES[0]
        : AVAILABLE_LANGUAGES[0];

export const API_DOC_LANGS_MAP = {
    ru: 'ru',
    en: 'en',
};

export const ROLE = {
    logist: 'TMS_LK_LOGIST',
    organizationAdmin: 'TMS_LK_ADMIN_ORGANIZATIONS',
    dispatcher: 'Dispatcher',
    anonymous: 'TMS_LK_PUBLIC_USER',
    base: 'TMS_LK_BASE_USER',
    empty: null,
    courier: 'TMS_LK_COURIER',
    systemOperator: 'TMS_LK_ADMIN',
};

export const MOBILE_ROLES = [ROLE.courier];

export const ROLE_ACCOUNT_TYPE = {
    //[ROLE.logist]: 'customer',
};

export const DISABLE_NOTIFICATIONS_ROLES = [ROLE.anonymous, ROLE.base];

export const SHARE_REPLAY_SETTINGS = { bufferSize: 1, refCount: true };

export const DOCUMENT_LINKS = {
    privacyPolicy: '/legal-documents/privacy_policy',
    userAgreement: '/legal-documents/site_rules',
    cookiePolicy: '/legal-documents/cookie_policy',
    personalDataConsent: '/legal-documents/personal_data_consent',
    oferta: '/legal-documents/offer_agreement',
};

export const DEFAULT_POLYGON_SETTINGS = {
    stroke: true,
    weight: 2,
    color: 'blue',
    fill: true,
    fillColor: 'blue',
    fillOpacity: 0.1,
    bubblingMouseEvents: true,
    interactive: true,
};

export const DEFAULT_LINK_ACTIVE_MATCH_OPTIONS: IsActiveMatchOptions =
    bazisConfig.DEFAULT_LINK_ACTIVE_MATCH_OPTIONS;

export const STAFF_WORK_MODES = [
    {
        id: 'car',
        icon: 'car',
    },
    {
        id: 'truck',
        icon: 'truck-car',
    },
    {
        id: 'on foot',
        icon: 'courier',
    },
    {
        id: 'motocycle',
        icon: 'motorbike',
    },
    {
        id: 'bicycle',
        icon: 'bike',
    },
    {
        id: 'electric scooter',
        icon: 'scooter',
    },
];

export const ROUTE_COLORS = [
    {
        id: 'purple',
        color: '#5A0CFF',
        colorKey: 'purple',
    },
    {
        id: 'violet',
        color: '#c30cff',
        colorKey: 'violet',
    },
    {
        id: 'green',
        color: '#62c986',
        colorKey: 'green',
    },
    {
        id: 'peach',
        color: '#e04171',
        colorKey: 'peach',
    },
    {
        id: 'blue',
        color: '#259ed1',
        colorKey: 'blue',
    },
    {
        id: 'teal',
        color: '#28cabf',
        colorKey: 'teal',
    },
    {
        id: 'turquoise',
        color: '#25a0a5',
        colorKey: 'turquoise',
    },
    {
        id: 'orange',
        color: '#ff8c47',
        colorKey: 'orange',
    },
    {
        id: 'pink',
        color: '#ff82cd',
        colorKey: 'pink',
    },
    {
        id: 'lightblue',
        color: '#aacfe4',
        colorKey: 'lightblue',
    },
    {
        id: 'yellow',
        color: '#faa33f',
        colorKey: 'yellow',
    },
    {
        id: 'darkorange',
        color: '#ff7347',
        colorKey: 'darkorange',
    },
];

export const PHONE_MASK = '+7 (999) 999-99-99';
export const PHONE_PATTERN = /\+7([0-9]){10}/;
export const PHONE_MASK_SETTINGS: Partial<MaskSettings> = {
    pipeMask: '+7 (000) 000-00-00',
    mask: '(000) 000-00-00',
    prefix: '+7 ',
    placeHolderCharacter: '_',
    dropSpecialCharacters: [' ', '-', '(', ')'],
    validation: false,
    keepCharacterPositions: false,
    showMaskTyped: true,
    outputTransformFn: (value) => {
        return value ? `+7${value}` : '';
    },
};
export const PHONE_INPUT_TRANSFORM_FN = bazisConfig.PHONE_INPUT_TRANSFORM_FN;

export const VEHICLE_MASK_SETTINGS: Partial<MaskSettings> = {
    ...bazisConfig.VEHICLE_MASK_SETTINGS,
    patterns: {
        V: {
            pattern: new RegExp('^[abekmhopctyxавекмнорстухABEKMHOPCTYXАВЕКМНОРСТУХ]'),
        },
        '0': {
            pattern: new RegExp('\\d'),
        },
        '9': {
            pattern: new RegExp('\\d'),
            optional: true,
        },
    },
};

export const NUMBER_PATTERN = /[0-9]/;
export const PASSPORT_RU_PATTERN = /^[0-9]{4}\s[0-9]{6}$/;
export const PASSPORT_RU_MASK_SETTINGS: Partial<MaskSettings> = {
    mask: '0000 000000',
    placeHolderCharacter: '_',
    dropSpecialCharacters: [],
    showMaskTyped: true,
};
export const DRIVER_RU_PATTERN = /^\d{2}\s\d{2}\s[a-zA-Z0-9]{6}$/;
export const DRIVER_RU_MASK_SETTINGS: Partial<MaskSettings> = {
    mask: '00 00 AAAAAA',
    placeHolderCharacter: '_',
    dropSpecialCharacters: [],
    showMaskTyped: true,
};

export const ALPHABET_DASH_SPACE_PATTERN = /^[a-zA-Zа-яА-ЯёЁ\- ]+$/;

export const ONBOARDING_STEPS = [
    {
        id: 'start-adding-objects',
        titleKey: 'onboarding.step_1.title',
        url: '/objects/geo-zones',
        elementSelector: '#tms-create-button',
        // shadowDomParentSelector: '.bazis-list-page__tools',
        placement: 'bottom',
    },
    {
        id: 'geozone-list',
        titleKey: 'onboarding.step_2.title',
        url: '/objects/geo-zones',
        elementSelector: '.tms-toolbar_tabs #tab-geozone',
        placement: 'bottom-start',
        hasOpacitybackground: true,
    },
    {
        id: 'warehouse-list',
        titleKey: 'onboarding.step_3.title',
        url: '/objects/warehouses',
        elementSelector: '.tms-toolbar_tabs #tab-warehouse',
        placement: 'bottom-end',
        hasOpacitybackground: true,
    },
    {
        id: 'courier-list',
        titleKey: 'onboarding.step_4.title',
        url: '/objects/couriers',
        elementSelector: '.tms-toolbar_tabs #tab-courier',
        placement: 'bottom-start',
        hasOpacitybackground: true,
    },
    {
        id: 'vehicle-list',
        titleKey: 'onboarding.step_5.title',
        url: '/objects/vehicles',
        elementSelector: '.tms-toolbar_tabs #tab-vehicles',
        placement: 'bottom-start',
        hasOpacitybackground: true,
    },
    {
        id: 'depot-list',
        titleKey: 'onboarding.step_6.title',
        url: '/objects/vehicle-depots',
        elementSelector: '.tms-toolbar_tabs #tab-vehicleDepot',
        placement: 'bottom-start',
        hasOpacitybackground: true,
    },
    {
        id: 'cargo-list',
        titleKey: 'onboarding.step_7.title',
        url: '/objects/cargos',
        elementSelector: '.tms-toolbar_tabs #tab-cargos',
        placement: 'bottom-start',
        hasOpacitybackground: true,
    },
    {
        id: 'end-adding-objects',
        titleKey: 'onboarding.step_8.title',
        url: '/objects/cargos',
        elementSelector: '.tms-header .bazis-segment__item:nth-child(2)',
        placement: 'bottom',
    },
    {
        id: 'goto-new-planning',
        titleKey: 'onboarding.step_9.title',
        descriptionKey: 'onboarding.step_9.description',
        url: '/routes/plannings/active',
        elementSelector: '#tms-create-planning-button',
        placement: 'bottom-end',
    },
    {
        id: 'variants-added-orders',
        titleKey: 'onboarding.step_10.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '.tms-variants-added-order',
        placement: 'top',
    },
    {
        id: 'variant-order-system',
        titleKey: 'onboarding.step_11.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-create-order-system',
        placement: 'end',
        mediaQuery: [
            {
                mediaQuery: '(min-height: 500px) and (max-height: 840px)',
                placement: 'top',
            },
        ],
    },
    {
        id: 'variant-order-import',
        titleKey: 'onboarding.step_12.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-create-order-import',
        placement: 'bottom',
        mediaQuery: [
            {
                mediaQuery: '(min-height: 500px) and (max-height: 840px)',
                placement: 'top',
            },
        ],
    },
    {
        id: 'variant-order-manual',
        titleKey: 'onboarding.step_13.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-create-order-manual',
        placement: 'top',
    },
    {
        id: 'new-order',
        titleKey: 'onboarding.step_14.title',
        url: '/routes/plannings/onboarding/edit/orders/onboarding/edit',
        elementSelector: '#tms-order-dialog',
        placement: 'start',
    },
    {
        id: 'fill-order',
        url: '/routes/plannings/onboarding/edit/orders/onboarding/edit',
        withoutBubble: true,
        animationDelay: 2000,
    },
    {
        id: 'planning-with-order',
        url: '/routes/plannings/onboarding/edit',
        withoutBubble: true,
        animationDelay: 1500,
        hasOpacitybackground: true,
    },
    {
        id: 'buttons-add-order',
        titleKey: 'onboarding.step_15.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-actions-added-order .bazis-dropdown__body',
        placement: 'bottom',
    },
    {
        id: 'planning-many-orders',
        url: '/routes/plannings/onboarding/edit',
        withoutBubble: true,
        animationDelay: 1500,
        hasOpacitybackground: true,
    },
    {
        id: 'goto-settings',
        titleKey: 'onboarding.step_16.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-goto-settings',
        placement: 'top',
    },
    {
        id: 'to-planning-settings',
        url: '/routes/plannings/onboarding/edit',
        withoutBubble: true,
        animationDelay: 10,
    },
    {
        id: 'planning-settings',
        titleKey: 'onboarding.step_17.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-planning-settings',
        placement: 'bottom',
    },
    {
        id: 'planning-settings-next',
        titleKey: 'onboarding.step_18.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-planning-settings-next',
        placement: 'top-end',
    },
    {
        id: 'to-planning-settings',
        url: '/routes/plannings/onboarding/edit',
        withoutBubble: true,
        animationDelay: 10,
    },
    {
        id: 'planning-executors-auto',
        titleKey: 'onboarding.step_19.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-planning-executors-auto',
        placement: 'bottom',
    },
    {
        id: 'to-planning-executors-manual',
        url: '/routes/plannings/onboarding/edit',
        withoutBubble: true,
        animationDelay: 10,
    },
    {
        id: 'planning-executors-manual-empty',
        titleKey: 'onboarding.step_20.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-planning-executors-manual-empty',
        placement: 'top',
        hasOpacitybackground: true,
    },
    {
        id: 'click-add-executors',
        titleKey: 'onboarding.step_21.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '.tms-click-add-executors',
        placement: 'bottom',
    },
    {
        id: 'accessible-executors',
        titleKey: 'onboarding.step_22.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-select-executors',
        placement: 'start',
    },
    {
        id: 'inappropriate-executors',
        titleKey: 'onboarding.step_23.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-select-executors',
        placement: 'start',
    },
    {
        id: 'goto-view-planning',
        titleKey: 'onboarding.step_24.title',
        url: '/routes/plannings/onboarding/edit',
        elementSelector: '#tms-goto-view-planning',
        placement: 'top-end',
    },

    {
        id: 'start-view-planning',
        url: '/routes/plannings/onboarding',
        withoutBubble: true,
        animationDelay: 1500,
        hasOpacitybackground: true,
    },
    {
        id: 'planning-steps',
        titleKey: 'onboarding.step_25.title',
        url: '/routes/plannings/onboarding',
        elementSelector: '#tms-planning-steps',
        placement: 'bottom',
    },
    {
        id: 'tab-unhandled',
        url: '/routes/plannings/onboarding',
        withoutBubble: true,
        animationDelay: 1500,
        hasOpacitybackground: true,
    },
    {
        id: 'reason-unhandled',
        titleKey: 'onboarding.step_26.title',
        url: '/routes/plannings/onboarding',
        elementSelector: '#tms-reason-unhandled',
        placement: 'end',
    },
    {
        id: 'view-planning',
        titleKey: 'onboarding.step_27.title',
        url: '/routes/plannings/onboarding',
        elementSelector: '.bazis-panel_right_top',
        placement: 'start',
    },
];

export const ICON_LOADED =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.4569 5.8188C12.725 5.56646 12.7378 5.14454 12.4855 4.87642C12.2331 4.60831 11.8112 4.59552 11.5431 4.84787L6.3474 9.73793L5.13807 8.5286C4.87772 8.26825 4.45561 8.26825 4.19526 8.5286C3.93491 8.78895 3.93491 9.21106 4.19526 9.47141L5.86193 11.1381C6.11672 11.3929 6.79024 11.1521 6.79024 11.1521L12.4569 5.8188Z" fill="#0C5CFF"/></svg>';
export const ICON_LOADING =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.45455C4.38505 1.45455 1.45455 4.38505 1.45455 8C1.45455 11.615 4.38505 14.5455 8 14.5455C11.615 14.5455 14.5455 11.615 14.5455 8C14.5455 4.38505 11.615 1.45455 8 1.45455ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" fill="#919FAE"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.90909C8.40166 2.90909 8.72727 3.2347 8.72727 3.63636V7.55052L11.2343 8.80405C11.5936 8.98368 11.7392 9.42054 11.5596 9.77979C11.38 10.139 10.9431 10.2847 10.5838 10.105L7.67475 8.65049C7.42837 8.5273 7.27273 8.27547 7.27273 8V3.63636C7.27273 3.2347 7.59834 2.90909 8 2.90909Z" fill="#919FAE"/></svg>';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService extends BazisConfigurationService {
    protected configuration: any = {
        tiles: {
            default: {
                url: 'https://{s}.map.asu.big3.ru/street/{z}/{x}/{y}.png',
                size: 256,
            },
            grey: {
                url: 'https://api.mapbox.com/styles/v1/smart-waste/cl7t82ptn006315lg5yiys80b/tiles/256/{z}/{x}/{y}?&access_token=pk.eyJ1Ijoic21hcnQtd2FzdGUiLCJhIjoiY2w3dDdyYWtvMDFzcjNucWxkaDR6aXk3dSJ9.DwsYQbL40ED-guYA9sE-0g',
                size: 256,
            },
        },
        emptyInputValue: '-',
        defaultLocation: [71.435819, 51.143964],
        contacts: { email: '', phone: '' },
        vehicleNumberMask: ['000', 'VVV', '00'],
        formComponentsIcons: {
            ...bazisConfig.CONTROL_ICONS,
            eraser: 'cross',
            caretUp: 'chevron-up',
            caretDown: 'chevron-down',
            angleUp: 'chevron-up',
            angleDown: 'chevron-down',
            interrogation: 'help-circle',
            left: 'chevron-left',
            right: 'chevron-right',
            trash: 'cross',
            coordinatesCopy: 'copy',
        },
        datapickerViewConfig: {
            typeHeadCalendar: 'center',
            typeSelectMonth: 'grid',
            iconLeft: 'chevron-left',
            iconRight: 'chevron-right',
            valueMonthWithComma: true,
            typeValueMonth: 'short',
        },
        controlInterrogationType: 'light',
        hasTabIndexToEraser: false,
    };

    protected settingsUrl = 'tms_system/settings';

    availableLanguages = AVAILABLE_LANGUAGES;

    selectedLanguage = SELECTED_LANGUAGE;

    get b3gisStandUrl() {
        return this.configuration?.B3GIS_STAND_URL || 'https://gis.big3.ru';
    }

    get b3gisMapSettings() {
        return this.configuration?.B3GIS_MAP_SETTINGS || {};
    }

    get bgTransitPlanningOrdersLimit() {
        return 50;
    }

    get maxAllSelectionCount() {
        return 10000;
    }

    get supportEmail() {
        return this.configuration?.SUPPORT_EMAIL;
    }

    get supportPhone() {
        return this.configuration?.SUPPORT_PHONE;
    }

    get signatureType(): 'crypto' | 'docusign' | 'NCALayer' {
        return 'NCALayer';
    }
}
